import { Location } from 'src/app/core/models/admin/location-admin.model';
import { Items } from 'src/app/core/models/common/items.model';
import {
  ACTIONS_TEXT,
  IMAGE_SRC,
  STATUS_OPTIONS,
} from '../../shared-constants';

export enum ColumnIds {
  LOCATION_CODE = 'locationCode',
  LOCATION_NAME = 'locationName',
  PORT_CODE = 'portCode',
  PACKAGE_SLIC = 'pkgSlic',
  COUNTRY = 'country',
  REGION = 'region',
  DISTRICT = 'district',
  TIME_ZONE = 'timeZone',
  LOCATION_GROUPS = 'locationGroups',
  MESSAGING = 'messaging',
  API_KEY = 'apiKey',
  ACTIONS = 'actions',
}

export const ColumnText = {
  LOCATION_CODE: $localize`Location Code`.toUpperCase(),
  LOCATION_NAME: $localize`Location Name`.toUpperCase(),
  PORT_CODE: $localize`PORT CODE`,
  PACKAGE_SLIC: $localize`PACKAGE SLIC`,
  COUNTRY: $localize`Country`.toUpperCase(),
  REGION: $localize`Region`.toUpperCase(),
  DISTRICT: $localize`District`.toUpperCase(),
  TIME_ZONE: $localize`Time Zone`.toUpperCase(),
  LOCATION_GROUPS_CODE: $localize`Group Code(s)`.toUpperCase(),
  MESSAGING: $localize`Messaging`.toUpperCase(),
  API_KEY: $localize`API KEY`,
};

export const CONSTS = {
  WELCOME_TEXT: $localize`Location Admin`,
  ACTIONS: ACTIONS_TEXT,
  CANCEL: `cancel`,
  ADD: `add`,
  REMOVE_LOCATION: $localize`Remove Location`,
  REMOVE_LOCATION_MSG: $localize`Please remove all users prior to deleting a location.`,
  OK: $localize`Ok`,
  DELETE: 'delete',
  EDIT: 'edit',
  YES: $localize`Yes`,
  NO: $localize`No`,
  CONFIRM_REMOVE: $localize`Are you sure you want to remove the following location:`,
  BACK: $localize`Back`,
  CONTINUE: $localize`Continue`,
  ALERT: $localize`ALERT!`,
};

export const MESSAGING_ICONS: Items[] = [
  { id: STATUS_OPTIONS.ACTIVE, src: IMAGE_SRC.ACTIVE, selected: true },
  { id: STATUS_OPTIONS.DEACTIVATED, src: IMAGE_SRC.CANCEL, selected: true },
];

export const GIO_ICONS: Items[] = [
  { id: STATUS_OPTIONS.ACTIVE, src: IMAGE_SRC.ACTIVE, selected: true },
  { id: STATUS_OPTIONS.DEACTIVATED, src: IMAGE_SRC.CANCEL, selected: true },
];

export const BYOD_ICONS: Items[] = [
  { id: STATUS_OPTIONS.ACTIVE, src: IMAGE_SRC.ACTIVE, selected: true },
  { id: STATUS_OPTIONS.DEACTIVATED, src: IMAGE_SRC.CANCEL, selected: true },
];

export const IDO_ICONS: Items[] = [
  { id: STATUS_OPTIONS.ACTIVE, src: IMAGE_SRC.ACTIVE, selected: true },
  { id: STATUS_OPTIONS.DEACTIVATED, src: IMAGE_SRC.CANCEL, selected: true },
];

export const API_KEY_ICONS: Items[] = [
  { id: STATUS_OPTIONS.ACTIVE, src: IMAGE_SRC.ACTIVE, selected: true },
  { id: STATUS_OPTIONS.DEACTIVATED, src: IMAGE_SRC.CANCEL, selected: true },
];

// Random countries, incomplete and will be replaced by back-end data
export const COUNTRY_DROPDOWN: Items[] = [
  { id: 'US', selected: true },
  { id: 'CN', selected: true },
  { id: 'GB', selected: true },
  { id: 'SA', selected: true },
  { id: 'FR', selected: true },
  { id: 'DE', selected: true },
  { id: 'ES', selected: true },
  { id: 'JP', selected: true },
  { id: 'UA', selected: true },
  { id: 'MX', selected: true },
  { id: 'AR', selected: true },
  { id: 'IT', selected: true },
  { id: 'AU', selected: true },
  { id: 'TW', selected: true },
  { id: 'IN', selected: true },
  { id: 'SE', selected: true },
  { id: 'NO', selected: true },
  { id: 'BR', selected: true },
  { id: 'KP', selected: true },
];

// same
export const REGION_DROPDOWN: Items[] = [
  { id: '01', selected: true },
  { id: '02', selected: true },
  { id: '03', selected: true },
  { id: '04', selected: true },
  { id: '05', selected: true },
  { id: '06', selected: true },
  { id: '07', selected: true },
  { id: '08', selected: true },
  { id: '09', selected: true },
  { id: '10', selected: true },
  { id: '11', selected: true },
  { id: '12', selected: true },
  { id: '13', selected: true },
  { id: '14', selected: true },
  { id: '15', selected: true },
  { id: '16', selected: true },
  { id: '17', selected: true },
  { id: '18', selected: true },
  { id: '19', selected: true },
  { id: '20', selected: true },
];

// same
export const DISTRICT_DROPDOWN: Items[] = [
  { id: '01', selected: true },
  { id: '02', selected: true },
  { id: '03', selected: true },
  { id: '04', selected: true },
  { id: '05', selected: true },
  { id: '06', selected: true },
  { id: '07', selected: true },
  { id: '08', selected: true },
  { id: '09', selected: true },
  { id: '10', selected: true },
];

// same
export const TIMEZONE_DROPDOWN: Items[] = [
  { id: 'AST', selected: true },
  { id: 'EST', selected: true },
  { id: 'CST', selected: true },
  { id: 'MST', selected: true },
  { id: 'PST', selected: true },
  { id: 'AK', selected: true },
  { id: 'HAST', selected: true },
  { id: 'SMST', selected: true },
];

export const MOCK_TABLE_CONSTS = [
  {
    id: 9734559,
    locationCode: 'TESTCODE',
    locationName: 'TESTNAME',
    portCode: 'TESTPORT',
    pkgSlic: '2425',
    country: 'IT',
    region: '16',
    district: '01',
    timeZone: 'EST',
    groupCode: 'ZZ',
    messaging: true,
    apiKey: true,
  },
];

export const EXCEL_FILE_NAME = $localize`location-admin-data`;

export type SelectedLocationType = Location & { index: number };
export type FilteredLocation = Omit<Location, 'id'>;
